import { Platform } from '@/utils/platform';
import { handle } from '../../QTBridge';
import { POPOBridgeEmitter } from '@popo-bridge/web';
import { bridgeEventEmitter, webEventEmitter } from '../../eventEmitter';
import { ToolTye } from '@/components/Note/utils';
import { callbackToNative } from '../../callhandle/callbackToNative';

export interface SelectToolResult {
  toolType: ToolTye; //工具类型
  params: Record<string, any>; //TODO 每个类型有自己的参数
}
export type SelectToolHandler = (evt: SelectToolResult) => void;

export const onSelectTool = async (cb: SelectToolHandler) => {
  if (Platform.isPOPO) {
    if (Platform.isPC) {
      return bridgeEventEmitter.addListener('selectTool', async (data, sessionId) => {
        cb(data as SelectToolResult);
        callbackToNative({
          status: 1,
          data: {},
          message: '',
          sessionId: sessionId as string,
        });
      });
    } else {
      return POPOBridgeEmitter.addListener('selectTool', async (data) => {
        cb(data);
      });
    }
  } else {
    return webEventEmitter.addListener('selectTool', (data: SelectToolResult) => {
      cb(data);
    });
  }
};
